(function () {
    'use strict';
    $(document).ready(function () {
        //filter element
        var filterElement = $('#filter');

        //base url
        var baseURL = filterElement.data('base-url');
        // if(baseURL.length === 0) console.error('Uzupełnij strony w opcjach w panelu.')

        filterElement.on('click', search);

        $('.clearFilters').on('click', clearFilters);

        function clearFilters() {
            $('input:checkbox:checked').removeAttr('checked');
            $(this).remove();
            window.location.assign(baseURL);
        }

        function search() {

            //list of arrays with areas and topics
            var selectsArray = [];
            var selects = $('.accordion');
            if($('.subpage.publications, .subpage.events').length) {
                selects = $('fieldset.select');

                //add two input[type=text] from publications page
                var input_names = ['tytul', 'fraza', 'autor', 'data_od', 'data_do'];
                for (var i=0; i < input_names.length; i++){
                    var input_name = input_names[i];
                    if ($('input[name=' + input_name + ']').length) {
                        if ($('input[name=' + input_name + ']').val().trim().length !== 0) {
                            selectsArray[input_name] = [$('input[name=' + input_name + ']').val().trim()];
                        }
                    }
                }
            }
            //current page
            var currentPage = $('#current-page').data('current-page');
            // if(currentPage > 1) selectsArray['strona'] = currentPage;



            // loop all checkboxes and push checked ones to array
            selects.each(function () {
                var currentID = $(this).data('get-name');
                selectsArray[currentID] = [];
                $(this).find('input[type=checkbox]:checked, input[type=radio]:checked').each(function () {
                    selectsArray[currentID].push($(this).attr('data-value'));
                })
            });

            //link building
            var counter = 0;
            var str = '';

            //iterate a array of selects
            for (var select_item in selectsArray) {

                // if current select is empty, just ignore it
                var currentSelect = selectsArray[select_item];
                if (currentSelect.length === 0) continue;

                // link build, determine if its first element
                if (counter === 0) str = '?' + select_item + '=';
                else str += '&' + select_item + '=';


                // build link and separate it by commas if its more than 1
                str += currentSelect.join(',');

                counter++;
            }

            window.location.assign(baseURL + str);

        }

        $('aside.sidebar .archive .accordion .collapse').on('shown.bs.collapse', function (e) {
            var containerHeight = $(this).actual('height');
            var contentHeight = $(this).find('.scroll-wrapper').actual('height');
            // console.log(containerHeight, contentHeight);
            if(contentHeight > containerHeight) {
                $(this).find('>.card-body').mCustomScrollbar({
                    axis: "y",
                    mouseWheel: {
                        enable: true
                    }
                });
            } else {
                $(this).find('>.card-body').mCustomScrollbar('destroy');
            }
        });
    });
}(jQuery));